import React from 'react'

function About() {
  return (
    <div>
        <nav className='navbar navbar-expand-lg navbar-dark bg-primary'>
            <div className="container">
                <a class="navbar-brand" href='#'>Dev Godwin</a>
                <button className='navbar-toggler' type='button' data-toogle='collapse' data-target='#navbarSupportedContent'>
                    <span className='navbar-toggler-icon'></span>
                </button>

                <div className='collapse navbar-collapse' id='navbarSupportedContent'>
                <ul class="navbar-nav ml-auto">
                    <li className="nav-item">
                    <a href="" className='nav-link'>Home</a>
                    </li>
                    <li className='nav-item dropdown'>
                    <a href="/about" className='nav-link dropdown-toggle' id='navbarDropdown' data-toggle='dropdown'>About</a>
                    <div className="dropdown-menu">
                        <a href="https://github.com/webgod1" className="dropdown-item">Github Link</a>
                        <a href="https://www.linkedin.com/in/godwin-samuel479723254" className="dropdown-item">LinkedIn Link</a>
                        <a href="https://www.twitter.com/godwinsam2006" className="dropdown-item">Twitter Link</a>
                        <div className="dropdown-divider"></div>
                        <a href="/about" className="dropdown-item">About Link</a>

                    </div>
                    </li>
                    <li className='nav-item'>
                    <a href="/project" className='nav-link'>Projects</a>
                    </li>
                    <li className='nav-item'>
                    <a href="#" className='nav-link'>Contact Me</a>
                    </li>
                </ul>
                </div>
            </div>
         </nav>
         <div className="container">
         <div className="jumbotron mt-3">
                <h2 className='text-center'>About Dev Godwin</h2>
                <p>I’m a frontend developer with 2 years of experience using my design skills, I create
                     beautiful user interface for
                      web applications, and I also write tests and
                       debug code to ensure quality. Have a certificate
                        in front End Devloper at Side Hustle Internship
                         <a href='https//www.Github.com/webgod1'> Github</a>, <a href="/project">Projects</a> </p>
                <div id='demo'>Lorem ipsum dolor, sit amet 
                    consectetur adipisicing elit. Iste autem fuga voluptate temporibus amet doloremque, 
                    distinctio provident ducimus corrupti quibusdam vitae minima itaque 
                    obcaecati laboriosam, repellat odio! Magnam sunt suscipit a, 
                    dignissimos provident doloremque!</div>
                    <a href='/mycv' className='btn btn-primary'>Resume</a>
            </div>
            <div className="row">
                <div className='col-lg-6 text-center'>
                    <div className="card text-center">
                        <h3 className='navbar-brand mt-2 text-center'>Links</h3>
                        <a href="https://github.com/webgod1" className='btn btn-success ml-2' style={{width: "97%"}}>Github</a>
                        <br />
                        <a href="https://www.linkedin.com/in/godwin-samuel479723254" className='btn btn-primary ml-2' style={{width: "97%"}}>LinkedIn</a>
                        <br />
                        <a href="https://www.twitter.com/godwinsam2006" className='btn btn-primary ml-2' style={{width: "97%"}}>Twitter</a>
                        <br />
                        <a href="/mycv" className='btn btn-warning ml-2' style={{width: "97%"}}>Resume</a>
                    </div>
                </div>
                <div className='col-lg-6 col-sm-12'>
                                <div className='card mb-3 '>

                                <h3 className=' sm-mt-3 text-center'>Skills</h3>
                                <p className='btn btn-primary   ml-2' style={{width: '97%'}}>HTML</p>
                                <p className='btn btn-primary  ml-2' style={{width: '97%'}}>CSS</p>
                                <p className='btn btn-primary  ml-2' style={{width: '97%'}}>JAVASCRIPT</p>
                                <br />
                                <p className='btn btn-primary  ml-2' style={{width: '97%'}}>BOOTSTRAP</p>
                                <p className='btn btn-primary  ml-2' style={{width: '97%'}}>REACT.JS</p>
                                <p className='btn btn-primary  ml-2' style={{width: '97%'}}>FIREBASE</p>
                                
                                </div>
                            </div>
            </div>
         </div>
         <div className='footer'>
                    <div className='container mt-2'>
                    <h2 style={{color: 'white', position: 'absolute'}} className='mt-3 text-center'>Dev Godwin</h2>
                    </div>
                </div>
    </div>
  )
}

export default About